const CheckedIconSelected = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6668 5L7.50016 14.1667L3.3335 10"
      stroke="url(#paint0_linear_785_28544)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_785_28544"
        x1="3.3335"
        y1="9.58365"
        x2="16.6675"
        y2="9.58365"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#000"/>
        <stop offset="1" stop-color="#000"/>
      </linearGradient>
    </defs>
  </svg>
);

export default CheckedIconSelected